const setTimerBanner = (date) => {
   const timerDate = document.querySelectorAll('[data-timer-date-banner]');
   const timerHours = document.querySelectorAll('[data-timer-hours-banner]');
   const timerMinutes = document.querySelectorAll('[data-timer-minutes-banner]');
   const timerSeconds = document.querySelectorAll('[data-timer-seconds-banner]');
 
   if (!timerDate.length) return;
 
   let distance;
 
   function timer() {
     // При изменении конечной даты в баннере вставляем сюда дату в формате (год, месяц[от 0 до 11], число, часы[от 0 до 23 и вычитаем разницу для Москвы], минуты, секунды)
     const utcDate = new Date(
       Date.UTC(
         date.getFullYear(),
         date.getMonth(),
         date.getDate() - 1,
         23-3,
         59,
         0
       )
     );
     const countDownDate = new Date(utcDate).getTime();
     const now = new Date().getTime();
     distance = countDownDate - now;
     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
     const seconds = Math. floor((distance % (1000 * 60)) / (1000));
 
     function plusZero(num) {
       if (num < 10) {
         return '0' + num;
       } else {
         return num;
       }
     }
 
     timerDate.forEach(date => date.textContent = `${plusZero(days)}`);
     timerHours.forEach(hour => hour.textContent = `${plusZero(hours)}`);
     timerMinutes.forEach(minute => minute.textContent = `${plusZero(minutes)}`);
     timerSeconds.forEach(second => second.textContent = `${plusZero(seconds)}`);
   };
 
   timer();
   const timeInterval = setInterval(timer, 1000);
 
   if (distance < 0) {
     clearInterval(timeInterval);      
     timerDate.forEach(date => date.textContent = `00`);
     timerHours.forEach(hour => hour.textContent = `00`);
     timerMinutes.forEach(minute => minute.textContent = `00`);
     timerSeconds.forEach(second => second.textContent = `00`);
   }
};

export default setTimerBanner;
 